import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";
import {
  Component,
  ElementRef,
  Inject,
  NgZone,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { ApiService } from "src/app/providers/api.service";
import { Observable, Subscription } from "rxjs";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import {
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { CdkOverlayOrigin } from "@angular/cdk/overlay";
import { SlotTimingsComponent } from "src/app/pages/new-v2-pages/new-v2-component/slot-timings/slot-timings.component";
import { redirectLoggedInTo } from "@angular/fire/auth-guard";
import { CalenderDialogComponent } from "src/app/shared/components/calender-dialog/calender-dialog.component";
import { CreateNewBookingComponent } from "src/app/shared/components/create-new-booking/create-new-booking.component";
import { InvoiceComponent } from "src/app/shared/components/invoice/invoice.component";
import { COUNTRY_CODES } from "src/app/shared/data/country-codes";
import { HttpClient } from "@angular/common/http";
import { debounceTime, filter, skip, switchMap } from "rxjs/operators";
import { AddJoiningInterestTimingsComponent } from "src/app/pages/new-v2-pages/new-v2-component/add-joining-interest-timings/add-joining-interest-timings.component";
import { MatSnackBar } from "@angular/material/snack-bar";
import { CustomConfirmDialogComponent } from "../custom-confirm-dialog/custom-confirm-dialog.component";
declare var google: any;

@Component({
  selector: "sm-add-member",
  templateUrl: "./add-member.component.html",
  styleUrls: ["./add-member.component.scss"],
})
export class AddMemberComponent implements OnInit, OnDestroy {
  toShowMap: boolean = false;
  toShowSessionInfo: boolean = false;
  online_session_link: any = null;
  online_session_notes: any = null;
  online_session_app: any = null;
  pay_in_advance: any = 0;
  @ViewChild("modalContainer") modalContainer!: ElementRef;
  isEntityIndividual: any = sessionStorage.getItem("isEntityIndividual");
  countryInfo: any =
    typeof sessionStorage.getItem(
      SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT,
    ) == "string"
      ? JSON.parse(
          sessionStorage.getItem(
            SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT,
          )!,
        )
      : sessionStorage.getItem(SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT);
  isEntityForeign: string = localStorage.getItem(
    SM_CONSTANTS.IS_ENTITY_FOREIGN,
  )!;
  memberimg: any = {
    img: null,
    thumb: null,
  };
  employeeList: any = [];
  home_status: any = sessionStorage.getItem("home_service_status");
  shop_status: any = sessionStorage.getItem("shop_service_status");
  virtual_status: any = sessionStorage.getItem("virtual_service_status");
  requestStatus: any = "1";
  public memberData: any = {
    price: 0,
    discount: 0,
    coupon_discount: 0,
    billing_period: 2,
  };
  selectedServiceType: any;
  repeatArray: any = new Array(0);
  form: UntypedFormGroup;
  selectedEmployee: any;
  tempObj: any;
  selectedDays: any = [];
  taxSlabData: any = [];
  productsList: any = [];
  private _apiSubscription: Subscription = new Subscription();
  selectedBookingType: number = 1;
  serviceList: any = [];
  discountInfo: any = null;
  constructor(
    @Inject(MAT_DIALOG_DATA) public parentData: any,
    public _snackBar: MatSnackBar,
    public _ngZone: NgZone,
    private _apiService: ApiService,
    private http: HttpClient,
    private fb: UntypedFormBuilder,
    public _modelRef: MatDialog,
    private loader: LoaderServiceService,
    private activemodal: MatDialogRef<CreateNewBookingComponent>,
  ) {
    setTimeout(() => {
      if (
        typeof google === "undefined" ||
        !google.maps ||
        !google.maps.places
      ) {
        console.error("Google Maps API failed to load in Safari <15.");
        return;
      }

      this.GoogleAutocomplete = new google.maps.places.AutocompleteService();
      this.geocoder = new google.maps.Geocoder();
    }, 500);
    this.form = this.fb.group({
      items: this.fb.array([]),
    });
  }
  uploadedImage: any = {};
  membershipSettings: any = {};

  ngOnInit(): void {
    console.log(this.parentData.data.memberData);

    this.home_status = sessionStorage.getItem("home_service_status");
    this.shop_status = sessionStorage.getItem("shop_service_status");
    this.virtual_status = sessionStorage.getItem("virtual_service_status");

    if (this.shop_status != 2) {
      this.selectedServiceType = "1";
    } else if (this.home_status != 2) {
      this.selectedServiceType = "0";
    } else if (this.virtual_status != 2) {
      this.selectedServiceType = "2";
    }

    let dateobj = this.getOneHourSlot(new Date());
    this.startTime = dateobj.start;
    this.endTime = dateobj.end;
    if (this.isEntityIndividual == "1") {
      let tempobj = {
        startTime: dateobj.start,
        endTime: dateobj.end,
        day: {
          dayName: this.getDayName(new Date().getDay()),
          day: new Date().getDay() + 1,
          timeSlots: [],
          is_selected: 1,
        },
      };

      this.selectedDays = [tempobj];
    }
    let data = this.parentData.data;
    if (this.parentData.data.memberData) {
      console.log("memberData", this.parentData.data.memberData);

      this.selectedServiceType =
        this.parentData.data.memberData.interest_type.toString();
    }
    // NOT WORKING
    if (this.parentData.memberData) {
      this.memberData.name = this.parentData.memberData.name;
      this.selectedCountryCode = this.countryList.find(
        (country) =>
          country.dial_code === this.parentData.memberData.countryCode,
      );
      this.memberData.phone = this.parentData.memberData.phone;
      this.memberimg.img = this.parentData.memberData?.img;
      this.memberimg.thumb = this.parentData.memberData?.img;
    }
    // this.discountInfo = this.parentData.data.discountInfo

    if (this.isEntityForeign == "0") {
      this._apiService.getEntityTaxSlabData(data.entityHash);
    } else if (this.isEntityForeign == "1") {
      this._apiService.getInternationalEntityTaxSlabsData(data.entityHash);
    }

    this._apiService.getEmployeeList(data.entityHash);

    this._apiService.getEntityProductList(data.entityHash, "1");
    this._apiService.getServicesTypesList(data.entityHash, "0", "0");
        this._apiService.getMemberAutoInvoiceSendingSettings(data.entityHash);

    this._apiSubscription = this._apiService.apiResult.subscribe((resData) => {
      console.log("inAddBookings2:", resData);
        if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_GET_MEMBER_AUTO_INVOICE_SENDING_SETTINGS
      ) {
        this.membershipSettings = {};
        if (resData.result) {
          this.membershipSettings = resData.result[0];
          if(this.membershipSettings?.default_online_session_link_status == 1){
            this.online_session_link = this.membershipSettings?.default_online_session_link
            this.online_session_app = this.membershipSettings?.default_online_session_app
          }
        }
      }
      if (
        resData.responseType === SM_CONSTANTS.GET_SERVICES_TYPES_LIST_RESULT
      ) {
        console.log(resData);

        this.serviceList = [];
        if (resData.result) {
          if (this.selectedServiceType == "1") {
            resData.result.forEach((element: any) => {
              if (element.shopStatus == 1 && element.status == 1) {
                element.toShow = true;
                this.serviceList.push(element);
              }
            });
            // this.itemListData = data.result.filter((x: { shopStatus: number; })=>x.shopStatus == 1);
          } else if (this.selectedServiceType == "0") {
            resData.result.forEach((element: any) => {
              if (element.homeStatus == 1 && element.status == 1) {
                element.toShow = true;
                this.serviceList.push(element);
              }
            });
            // this.itemListData = data.result.filter((x: { homeStatus: number; })=>x.homeStatus == 1);
          } else if (this.selectedServiceType == "2") {
            resData.result.forEach((element: any) => {
              if (element.for_virtual == 1 && element.status == 1) {
                element.toShow = true;
                this.serviceList.push(element);
              }
            });
            // this.itemListData = data.result.filter((x: { homeStatus: number; })=>x.homeStatus == 1);
          }
        }

        if (this.parentData.data.memberData) {
          let dialogMemberData = this.parentData.data.memberData;
          this.memberData.name = dialogMemberData.customer_name;
          this.memberData.email =
            dialogMemberData.email &&
            dialogMemberData.email != "" &&
            dialogMemberData.email != "null" &&
            dialogMemberData.email != "---"
              ? dialogMemberData.email
              : null;
          this.memberData.address = dialogMemberData?.user_profile_data
            ?.address_info?.address_line
            ? dialogMemberData?.user_profile_data?.address_info?.address_line
            : null;
          this.memberData.dob = dialogMemberData?.user_profile_data?.dob
            ? this.formatDate1(
                new Date(dialogMemberData?.user_profile_data?.dob),
              )
            : null;
          this.memberData.gender = dialogMemberData?.user_profile_data?.gender
            ? dialogMemberData?.user_profile_data?.gender
            : null;
          this.memberData.note = dialogMemberData?.customer_notes
            ? dialogMemberData?.customer_notes
            : null;
          this.selectedCountryCode = this.countryList.find(
            (country) =>
              country.dial_code === dialogMemberData.customer_country_code,
          );
          this.memberData.phone = dialogMemberData.customer_phone;
          // this.memberData.coupon_discount = dialogMemberData.coupon_discount && dialogMemberData.coupon_discount != 0 ? dialogMemberData.coupon_discount : 0
          this.memberData.coupon_code = dialogMemberData.coupon_code;
          if (dialogMemberData.request_timings) {
            this.selectedDays = dialogMemberData.request_timings.map(
              (item: any) => {
                return {
                  startTime: item.start_time.slice(0, 5),
                  endTime: item.end_time.slice(0, 5),
                  day: {
                    dayName: this.getDayName(item.weekday - 1),
                    day: item.weekday,
                    timeSlots: [],
                    is_selected: 1,
                  },
                };
              },
            );
          } else if (!dialogMemberData.request_timings) {
            this.selectedDays = [];
          }

          if (dialogMemberData.request_services) {
            dialogMemberData.request_services.forEach((element: any) => {
              this.selectServicesForEdit(element);
              // if(element.current_status == 3){
              // }
            });
          }

          if (dialogMemberData.custom_items) {
            dialogMemberData.custom_items =
              typeof dialogMemberData.custom_items == "string"
                ? JSON.parse(dialogMemberData.custom_items)
                : dialogMemberData.custom_items;
            dialogMemberData.custom_items.forEach((element: any) => {
              if (element) {
                this.items.push(this.createFieldWithItem(element));
              }
              // if(element.current_status == 3){
              // }
            });
          }
        }
        this.loader.showLoader = false;
        this.calculateCouponDiscount();
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_UPDATE_BOOKING_STATUS_FOR_NEW_BOOKING
      ) {
        if (resData.result) {
          this.loader.showLoader = false;
          this.activemodal.close({
            selectedBookingType: this.selectedBookingType,
            bookingData: this.tempObj,
          });
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_ADD_EDIT_ENROLL_INTEREST_BY_ENTITY
      ) {
        if (resData.result) {
          this.loader.showLoader = false;
          this.activemodal.close({ msg: "success" });
        }
      }
      if (
        resData.responseType === SM_CONSTANTS.RESULT_API_ADD_EDIT_ENROLL_MEMBERS
      ) {
        if (resData.result) {
          if (resData.result) {
            if (resData.result.errorcode == 1) {
              this.loader.showLoader = false;
              const dialogRef = this._modelRef.open(
                CustomConfirmDialogComponent,
                {
                  width: "500px",
                  data: {
                    title: "Alert",
                    message:
                      "There's another member with the same name and phone number exists. If you really want to create one, change the name or phone number.",
                    okbtn: "Ok",
                    cancelbtn: "Cancel",
                    type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
                  },
                  disableClose: true,
                },
              );
            } else if (resData.result.errorcode == 2) {
              this.loader.showLoader = false;
              const dialogRef = this._modelRef.open(
                CustomConfirmDialogComponent,
                {
                  width: "500px",
                  data: {
                    title: "Alert",
                    message:
                      "There's a person with the same name and phone number exists as your ex member. You can revive the membership again in 'Ex-members' section. Or change the member info.",
                    okbtn: "Ok",
                    cancelbtn: "Cancel",
                    type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
                  },
                  disableClose: true,
                },
              );
            } else if (resData.result.errorcode == 0) {
              this.activemodal.close(resData.result);
            }
            // this.loader.showLoader = false
          }
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_UPDATE_BOOKING_STATUS_WITH_INVOICE
      ) {
        if (resData.result) {
          this.parentData.ref.closeAll();

          this._modelRef.open(InvoiceComponent, {
            width: "510px",
            data: {
              title: "Invoice",
              ref: this._modelRef,
              data: JSON.parse(resData.result).bookingHashId,
            },
          });
        }
      }
      if (resData.responseType === SM_CONSTANTS.UPLOAD_RESULT) {
        this.uploadedImage = {};
        console.log(resData.result.url);
        this._ngZone.run(() => {
          setTimeout(() => {
            this.uploadedImage.imgUrl = resData.result?.url;
            this.uploadedImage.thumbnail = resData.result?.thumbnail;

            this.memberimg.img = resData.result?.url;
            this.memberimg.thumb = resData.result?.thumbnail;

            // this.memberData.profileThumbImg = resData.result?.url
            // this.memberData.profileThumbImgReal = resData.result?.thumbnail

            // this.memberData.profileImg = resData.result?.url
            this.loader.showLoader = false;
          }, 3000);
        });
        // this.newSalaryData.imgUrl = res.result?.url;fff
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_GET_ENTITY_TAX_SLAB_DATA
      ) {
        this.taxSlabData = [];
        if (resData.result) {
          this.taxSlabData = resData.result.filter(
            (item: any) => item.tax_collection_status == 1,
          );
        } else {
          // this.isTaxApplicable = true
          // this.loaderservice.showLoader = false
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_GET_INTERNATIONAL_ENTITY_TAX_SLAB_DATA
      ) {
        this.taxSlabData = [];
        if (resData.result) {
          this.taxSlabData = resData.result.filter(
            (item: any) => item.tax_collection_status == 1,
          );
        } else {
          // this.isTaxApplicable = true
          // this.loaderservice.showLoader = false
        }
      }
      if (
        resData.responseType === SM_CONSTANTS.RESULT_API_GET_ENTITY_PRODUCT_LIST
      ) {
        console.log(resData);

        this.productsList = [];
        if (resData.result) {
          if (this.selectedServiceType == "1") {
            resData.result.forEach((element: any) => {
              if (element.shop_status == 1 && element.status == 1) {
                element.toShow = true;
                this.productsList.push(element);
              }
            });
            // this.itemListData = data.result.filter((x: { shopStatus: number; })=>x.shopStatus == 1);
          } else if (this.selectedServiceType == "0") {
            resData.result.forEach((element: any) => {
              if (element.home_status == 1 && element.status == 1) {
                element.toShow = true;
                this.productsList.push(element);
              }
            });
            // this.itemListData = data.result.filter((x: { homeStatus: number; })=>x.homeStatus == 1);
          } else if (this.selectedServiceType == "2") {
            resData.result.forEach((element: any) => {
              if (element.virtual_status == 1 && element.status == 1) {
                element.toShow = true;
                this.productsList.push(element);
              }
            });
            // this.itemListData = data.result.filter((x: { homeStatus: number; })=>x.homeStatus == 1);
          }
          if (this.parentData.data.memberData) {
            if (this.parentData.data.memberData.products) {
              this.parentData.data.memberData.products.forEach(
                (element: any) => {
                  // this.selectServicesForEdit(element)
                  this.selectProducts(element);
                  // if(element.current_status == 3){
                  // }
                },
              );
            }
          }
        }

        this.calculateCouponDiscount();
      }

      if (resData.responseType === SM_CONSTANTS.GET_EMPLOYEE_LIST_RESULT) {
        this.employeeList = [];
        if (resData.result) {
          resData.result.forEach((element: any) => {
            if (element.isExEmployee != 1) {
              this.employeeList.push(element);
            }
          });
        }
      }
    });
  }

  countryList: {
    name: string;
    dial_code: string;
    code: string;
    flag: string;
    preferred?: any;
  }[] = COUNTRY_CODES;
  selectedCountryCode: any = this.countryList.find(
    (country) => country.dial_code === "+91",
  );
  searchString: UntypedFormControl = new UntypedFormControl("");
  onCountrySelected(event: any): void {
    this.searchString.reset();
    this.countryList = COUNTRY_CODES;
  }

  openTimings() {
    // this.loader.showLoader = true
    let dialogref = this._modelRef.open(AddJoiningInterestTimingsComponent, {
      width: "450px",
      data: {
        title: "Select day and time",
        serviceType: this.selectedServiceType,
      },
    });

    dialogref.afterClosed().subscribe((res) => {
      if (res) {
        console.log(res);
        res.forEach((element: any) => {
          this.selectedDays.push(element);
        });
      }
    });
  }

  assetType: number = 0;
  public fileName: string = "";
  public assetList: any[] = [];
  onUploadImage(event: any) {
    this.assetType = 0;
    console.log(event);
    console.log(event.target);

    console.log(event.target.files);
    if (event.target.value === "") {
      // this.loader = false;
      return;
    }
    this.fileName = event.target.files[0].name;

    if (this.fileName.includes(" ")) {
      this.fileName = this.fileName.replace(/\s+/g, "_");
    }
    let sizeinKb = +event.target.files[0].size / 1000;
    // if (sizeinKb > 1021) {
    //   this._snackBar.open('Image size should not exceed more then 1 mb', 'Ok');
    //   return;
    // }
    let extension = this.fileName.substring(this.fileName.lastIndexOf(".") + 1);
    const mimeType = event.target.files[0].type;
    console.log(extension);
    // this.assetList.push({
    //   assetName: this.fileName,
    // });
    // this.loader = true;
    let formData: FormData = new FormData();
    formData.append("recfile", event.target.files[0]);

    if (mimeType.startsWith("image/")) {
      console.log("image");
      if (sizeinKb > 5120) {
        // this.loader = false;
        this._snackBar.open(
          "Image size should not exceed more then 1 mb",
          "Ok",
        );
        return;
      }
      this.assetType = 1;
      this.loader.showLoader = true;
      this._apiService.uploadAssets(formData, 2);
      return;
    }
    if (mimeType.startsWith("video/")) {
      console.log("Video");
      if (sizeinKb > 15360) {
        // this.loader = false;
        this._snackBar.open(
          "Image size should not exceed more then 1 mb",
          "Ok",
        );
        return;
      }
      this.assetType = 2;
      this.loader.showLoader = true;
      this._apiService.uploadAssets(formData, 3);
      return;
    }
    // this.loader = false;
    this._snackBar.open("File format not supported", "Ok");
  }

  changeServiceType(type: string) {
    this.selectedJobs = [];
    this.memberData.price = 0;
    this.selectedServiceType = type;
    this.loader.showLoader = true;
    this._apiService.getServicesTypesList(
      this.parentData.data.entityHash,
      "0",
      "0",
    );
    this._apiService.getEntityProductList(this.parentData.data.entityHash, "1");
  }

  onKey() {
    console.log(this.searchString.value);

    this.countryList = [];
    this.selectSearch(this.searchString.value);
  }
  selectSearch(value: string) {
    let filter = value.toLowerCase();
    for (let i = 0; i < COUNTRY_CODES.length; i++) {
      let option = COUNTRY_CODES[i];
      if (option.name.toLowerCase().indexOf(filter) >= 0) {
        this.countryList.push(option);
      }
    }
  }
  today = new Date();
  selectedDate: any = null;
  onSelectDate() {
    const dialogRef = this._modelRef.open(CalenderDialogComponent, {
      width: "350px",
      panelClass: "calender-dialog-container",
      data: {
        selectedDate: this.today,
      },
    });
    dialogRef.afterClosed().subscribe((data: any) => {
      if (data) {
        this.selectedBookingType = 5;
        this.selectedDate = data;
        console.log(this.today);

        // this.ngOnInit();
      }
    });
  }

  formChecker(): boolean {
    const phone = this.memberData?.phone?.trim(); // safely get phone, remove spaces

    // Check if phone is missing or empty
    if (!phone) {
      return true;
    }

    // Check length between 3 and 17
    return phone.length < 3 || phone.length > 17;
  }

  namechecker() {
    if (this.memberData.name && this.memberData.name.trim() !== "") {
      return false; // valid
    } else {
      return true; // invalid
    }
  }
  selectedDaysChecker() {
    if (this.isEntityIndividual == "1") {
      if (this.selectedDays.length == 0) {
        return true;
      } else {
        return false;
      }
    } else if (this.isEntityIndividual == "0") {
      return false;
    } else {
      return false;
    }
  }
  serviceInfo: any = [];
  productInfo: any = [];
  onPost() {
    this.serviceInfo = [];

    this.selectedJobs.forEach((element: any) => {
      this.serviceInfo.push({
        service_type_hash: element.hash_id,
        service_name: element.serviceName,
        service_qty: element.selectedCount,
        service_description: element.description,
        service_img_url: element.imgUrl,
        service_rate: element.price,
        service_time: element.approxTime,
        service_sac_code: element.service_sac_code,
        tax_slab_hash: element.tax_slab_hash,
      });
    });

    this.productInfo = this.selectedProducts.map((item: any) => {
      return {
        product_name: item.product_name,
        product_desc: item.product_desc,
        entity_product_hash: item.hash_id,
        product_img_url: item.thumb_image_url,
        product_price: item.price,
        product_qty: item.selectedCount,
        tax_slab_hash: item.tax_slab_hash,
        hsn_code: item.product_hsn_code,
      };
    });

    // --------------- new data formation --------------------

    let obj = {
      // "hash_id": "21b296bb295a9c1800c8aa373bb6a6601acf5950",
      entity_hash: this.parentData.data.entityHash,
      member_account_hash: this.parentData.data.memberData
        ? this.parentData.data.memberData.customer_account_hash
        : null,
      enroll_request_hash: this.parentData.data.memberData
        ? this.parentData.data.memberData.hash_id
        : null,
      name: this.memberData.name ? this.memberData.name : "New Customer",
      country_code: this.selectedCountryCode.dial_code,
      phone: this.memberData.phone ? this.memberData.phone : "0000000000",
      gender: this.memberData.gender ? this.memberData.gender : null,
      billing_period: this.memberData.billing_period
        ? this.memberData.billing_period
        : null,
      service_mode: this.selectedServiceType,
      dob: this.memberData.dob ? this.formatDate1(this.memberData.dob) : null,
      start_date: this.memberData.start_date
        ? this.formatDate1(this.memberData.start_date)
        : null,
      image_url: this.memberimg.img ?? null,
      image_thumb_url: this.memberimg.thumb ?? null,
      email: this.memberData.email,
      services: this.serviceInfo,
      products: this.productInfo,
      coupon_code: this.parentData.data.memberData?.coupon_code ?? null,
      address: this.memberData.address ?? null,

      timings: this.selectedDays.map((item: any) => {
        return {
          weekday: item.day.day,
          start_time: item.startTime,
          end_time: item.endTime,
        };
      }),
      custom_items: this.form.get("items")!.value.map((item: any) => {
        return {
          item_name: item.name.item_name ? item.name.item_name : item.name,
          item_desc: item.name.item_desc ?? "",
          item_inventory_hash: item.name.hash_id ?? "",
          item_img_url: item.name.image_thumb_url ?? "",
          item_qty: item.count,
          item_price: +item.price,
          tax_slab_hash: item.tax_slab == "default" ? null : item.tax_slab,
        };
      }),
      note: this.memberData.note,
      default_assign_to_hash: this.selectedEmployee?.employeeHashId ?? null,
      subscription_fee: this.memberData.price,
      discount: this.memberData.discount,
      pay_in_advance: this.pay_in_advance,
      net_payable: (this.memberData.price - this.memberData.discount).toFixed(
        2,
      ),

      creation_date: this.formatDateString(new Date()),
      created_by: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
   online_session_link: undefined as any,
      online_session_notes: undefined as any,
      online_session_app: undefined as any,
      member_address: undefined as any,
    };

    if (this.selectedServiceType == "0") {
      // INSERT ADDRESS OBJ
      obj.member_address = {
          landmark: this.landmark,
          street_name: this.streetName,
          house_no: this.houseNumber,
          city: this.selectedLocation.city,
          state: this.selectedLocation.state,
          country: this.selectedLocation.country,
          zip: this.selectedLocation.zip,
          lat: this.lat,
          lng: this.lng,
          address_line: this.formattedAddress,
          service_mode: this.selectedServiceType,
          status: 1,
          created_by: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
          country_code: this.contactselectedCountryCode.dial_code,
          phone: this.phone,
        };

        Object.keys(obj.member_address).forEach((key) => {
          if (
            (obj.member_address as any)[key] === null ||
            (obj.member_address as any)[key] ===
              undefined ||
            (obj.member_address as any)[key] === "" ||
            (obj.member_address as any)[key] === "null"
          ) {
            delete (obj.member_address as any)[key];
          }
        });
    }
    if (this.selectedServiceType == "2") {
      // INSERT ONLINE SESSION INFO OBJ
      obj.online_session_link = this.online_session_link;
      obj.online_session_notes =
        this.online_session_notes;
      obj.online_session_app = this.online_session_app;
    }

    Object.keys(obj).forEach((key) => {
      if ((obj as any)[key] === null || (obj as any)[key] === undefined) {
        delete (obj as any)[key];
      }
    });
    obj.services.forEach((element: any) => {
      Object.keys(element).forEach((key) => {
        if ((element as any)[key] === null) {
          delete (element as any)[key];
        }
      });
    });
    obj.products.forEach((element: any) => {
      Object.keys(element).forEach((key) => {
        if ((element as any)[key] === null) {
          delete (element as any)[key];
        }
      });
    });
    obj.custom_items.forEach((element: any) => {
      Object.keys(element).forEach((key) => {
        if ((element as any)[key] === null) {
          delete (element as any)[key];
        }
      });
    });
    console.log(obj);

    this.loader.showLoader = true;
    this._apiService.addEdiEnrolledMember(obj);
  }

  formatDate1(dateStr: Date) {
    let curdate = new Date(dateStr)
      .toLocaleString("en-CA", {
        timeZone: "Asia/Kolkata",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .slice(0, 10);

    return curdate;
  }

  allDone() {
    this.serviceInfo = [];

    this.selectedJobs.forEach((element: any) => {
      this.serviceInfo.push({
        service_hash_id: element.hash_id,
        service_name: element.serviceName,
        description: element.description,
        img_url: element.imgUrl,
        approxTime: element.approxTime,
        completed_by_hash_id: localStorage.getItem(
          SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID,
        ),
        service_cost:
          this.selectedServiceType == "0"
            ? element.discountStatus == 1
              ? element.homeDiscountedPrice
              : element.home_rate
            : element.discountStatus == 1
            ? element.shopDiscountedPrice
            : element.shop_rate,
        current_status: 3,
      });
    });

    let data = {
      bookingStatusInfo: {
        assignedToHash: localStorage.getItem(
          SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID,
        ),
        bookingType: this.selectedServiceType,
        appointmentHash: "",
        assignedByHash: localStorage.getItem(
          SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID,
        ),
        entityHash: this.parentData.data.entityHash,
        bookingStatus: this.selectedBookingType,
        price: this.memberData.price.toString(),
        startTime: this.formatTime(new Date()),
        endTime: this.formatTime(new Date()),
        note: this.memberData.note ? this.memberData.note : "",
        customerPh: this.memberData.customerPh
          ? this.selectedCountryCode.dial_code + this.memberData.customerPh
          : this.selectedCountryCode.dial_code + "0000000000",
        customerName: this.memberData.customerName
          ? this.memberData.customerName
          : "New Customer",
        completedServices: this.serviceInfo,
        bookingDate: this.formatDateString(new Date()),
      },
    };

    console.log(data);
    this.loader.showLoader = true;
    this._apiService.updateBookingStatusWithInvoice(data);
  }

  completedServices: any = [];
  partiallyDone() {
    this.selectedJobs.forEach((element: any) => {
      this.completedServices.push({
        service_hash_id: element.hash_id,
        service_name: element.serviceName,
        description: element.description,
        imgUrl: element.imgUrl,
        approxTime: element.approxTime,
        completed_by_hash_id: localStorage.getItem(
          SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID,
        ),
        service_cost:
          this.selectedServiceType == "0"
            ? element.discountStatus == 1
              ? element.homeDiscountedPrice
              : element.home_rate
            : element.discountStatus == 1
            ? element.shopDiscountedPrice
            : element.shop_rate,
        current_status: 3,
      });
    });

    let data = {
      bookingStatusInfo: {
        appointmentHash: "",
        assignedToHash: localStorage.getItem(
          SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID,
        ),
        bookingType: this.selectedServiceType,
        assignedByHash: localStorage.getItem(
          SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID,
        ),
        entityHash: this.parentData.data.entityHash,
        bookingStatus: 9,
        price: this.memberData.price,
        startTime: this.formatTime(new Date()),
        endTime: this.addOneHourAndFormat(new Date()),
        note: this.memberData.note,
        customerPh: this.memberData.customerPh
          ? this.selectedCountryCode.dial_code + this.memberData.customerPh
          : this.selectedCountryCode.dial_code + "0000000000",
        customerName: this.memberData.customerName
          ? this.memberData.customerName
          : "New Customer",
        completedServices: this.completedServices,
        bookingDate: this.formatDateString(new Date()),
      },
    };

    console.log(data);
    this.loader.showLoader = true;
    this._apiService.updateBookingStatus(data);
  }
  allDoneAndRelease() {
    this.selectedJobs.forEach((element: any) => {
      this.completedServices.push({
        service_hash_id: element.hash_id,
        service_name: element.serviceName,
        description: element.description,
        imgUrl: element.imgUrl,
        approxTime: element.approxTime,
        completed_by_hash_id: localStorage.getItem(
          SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID,
        ),
        service_cost:
          this.selectedServiceType == "0"
            ? element.discountStatus == 1
              ? element.homeDiscountedPrice
              : element.home_rate
            : element.discountStatus == 1
            ? element.shopDiscountedPrice
            : element.shop_rate,
        current_status: 3,
      });
    });

    let data = {
      bookingStatusInfo: {
        appointmentHash: "",
        assignedToHash: localStorage.getItem(
          SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID,
        ),
        bookingType: this.selectedServiceType,
        assignedByHash: localStorage.getItem(
          SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID,
        ),
        entityHash: this.parentData.data.entityHash,
        bookingStatus: 4,
        price: this.memberData.price,
        startTime: this.formatTime(new Date()),
        endTime: this.addOneHourAndFormat(new Date()),
        note: this.memberData.note,
        customerPh: this.memberData.customerPh
          ? this.selectedCountryCode.dial_code + this.memberData.customerPh
          : this.selectedCountryCode.dial_code + "0000000000",
        customerName: this.memberData.customerName
          ? this.memberData.customerName
          : "New Customer",
        completedServices: this.completedServices,
        bookingDate: this.formatDateString(new Date()),
      },
    };

    console.log(data);
    this.loader.showLoader = true;
    this._apiService.updateBookingStatus(data);
  }

  changeChip(value: number) {
    this.selectedDate = null;
    this.selectedBookingType = value;
    if (value == 1) {
      this.selectedDate = new Date();
    } else if (value == 4) {
      let tempDate = new Date();
      tempDate.setDate(tempDate.getDate() + 1);
      this.selectedDate = new Date(tempDate);
    }
    // this.loader = true
    // this._apiService.getEntitySlotsInfo(this.entityHashId, this.bookingType, this.selectedValue)
  }
  decreaseServiceCount(item: any, index: any) {
    if (this.selectedJobs[index].selectedCount == 1) {
      const index1 = this.serviceList.findIndex(
        (x: any) => x.hash_id == item.hash_id,
      );
      // const index1 = this.selectedJobs.findIndex( (x:any)=>x.hash_id == item.hash_id);

      if (this.selectedServiceType == "0") {
        if (this.selectedJobs[index].discountStatus == 1) {
          this.memberData.price -= this.selectedJobs[index].homeDiscountedPrice;
        } else if (this.selectedJobs[index].discountStatus == 0) {
          this.memberData.price -= this.selectedJobs[index].home_rate;
        }
      } else if (this.selectedServiceType == "1") {
        if (this.selectedJobs[index].discountStatus == 1) {
          this.memberData.price -= this.selectedJobs[index].shopDiscountedPrice;
        } else if (this.selectedJobs[index].discountStatus == 0) {
          this.memberData.price -= this.selectedJobs[index].shop_rate;
        }
      } else if (this.selectedServiceType == "2") {
        if (this.selectedJobs[index].discountStatus == 1) {
          this.memberData.price -=
            this.selectedJobs[index].virtual_discounted_amount;
        } else if (this.selectedJobs[index].discountStatus == 0) {
          this.memberData.price -= this.selectedJobs[index].virtual_rate;
        }
      }

      this.serviceList[index1].toShow = true;
      this.selectedJobs.splice(index, 1);
    } else {
      item.price -= item.price / item.selectedCount;
      this.selectedJobs[index].selectedCount--;

      if (this.selectedServiceType == "0") {
        if (this.selectedJobs[index].discountStatus == 1) {
          this.memberData.price -= this.selectedJobs[index].homeDiscountedPrice;
        } else if (this.selectedJobs[index].discountStatus == 0) {
          this.memberData.price -= this.selectedJobs[index].home_rate;
        }
      } else if (this.selectedServiceType == "1") {
        if (this.selectedJobs[index].discountStatus == 1) {
          this.memberData.price -= this.selectedJobs[index].shopDiscountedPrice;
        } else if (this.selectedJobs[index].discountStatus == 0) {
          this.memberData.price -= this.selectedJobs[index].shop_rate;
        }
      } else if (this.selectedServiceType == "2") {
        if (this.selectedJobs[index].discountStatus == 1) {
          this.memberData.price -=
            this.selectedJobs[index].virtual_discounted_amount;
        } else if (this.selectedJobs[index].discountStatus == 0) {
          this.memberData.price -= this.selectedJobs[index].virtual_rate;
        }
      }
    }
    this.calculateCouponDiscount();
  }
  increaseServiceCount(item: any, index: any) {
    item.price += item.price / item.selectedCount;
    this.selectedJobs[index].selectedCount++;

    // const index = this.serviceList.findIndex( (x:any)=>x.hash_id == item.hash_id);
    // const index1 = this.selectedJobs.findIndex( (x:any)=>x.hash_id == item.hash_id);

    if (this.selectedServiceType == "0") {
      if (this.selectedJobs[index].discountStatus == 1) {
        this.memberData.price += this.selectedJobs[index].homeDiscountedPrice;
      } else if (this.selectedJobs[index].discountStatus == 0) {
        this.memberData.price += this.selectedJobs[index].home_rate;
      }
    } else if (this.selectedServiceType == "1") {
      if (this.selectedJobs[index].discountStatus == 1) {
        this.memberData.price += this.selectedJobs[index].shopDiscountedPrice;
      } else if (this.selectedJobs[index].discountStatus == 0) {
        this.memberData.price += this.selectedJobs[index].shop_rate;
      }
    } else if (this.selectedServiceType == "2") {
      if (this.selectedJobs[index].discountStatus == 1) {
        this.memberData.price +=
          this.selectedJobs[index].virtual_discounted_amount;
      } else if (this.selectedJobs[index].discountStatus == 0) {
        this.memberData.price += this.selectedJobs[index].virtual_rate;
      }
    }

    this.calculateCouponDiscount();
  }

  selectedJobs: any = [];
  selectServices(item: any) {
    console.log(item);

    const index = this.serviceList.findIndex(
      (x: any) => x.hash_id == item.hash_id,
    );
    this.serviceList[index].selectedCount = 1;

    this.serviceList[index].price =
      this.selectedServiceType == "0"
        ? item.discountStatus == 1
          ? item.homeDiscountedPrice
          : item.home_rate
        : this.selectedServiceType == "1"
        ? item.discountStatus == 1
          ? item.shopDiscountedPrice
          : item.shop_rate
        : item.discountStatus == 1
        ? item.virtual_discounted_amount
        : item.virtual_rate;

    this.selectedJobs.push(this.serviceList[index]);
    if (this.selectedServiceType == "0") {
      if (
        this.serviceList[index].discountStatus &&
        this.serviceList[index].discountStatus == 1
      ) {
        this.memberData.price += this.serviceList[index].homeDiscountedPrice;
      } else if (
        !this.serviceList[index].discountStatus ||
        this.serviceList[index].discountStatus == 0
      ) {
        this.memberData.price += this.serviceList[index].home_rate;
      }
    } else if (this.selectedServiceType == "1") {
      if (
        this.serviceList[index].discountStatus &&
        this.serviceList[index].discountStatus == 1
      ) {
        this.memberData.price += this.serviceList[index].shopDiscountedPrice;
      } else if (
        !this.serviceList[index].discountStatus ||
        this.serviceList[index].discountStatus == 0
      ) {
        this.memberData.price += this.serviceList[index].shop_rate;
      }
    } else if (this.selectedServiceType == "2") {
      if (
        this.serviceList[index].discountStatus &&
        this.serviceList[index].discountStatus == 1
      ) {
        this.memberData.price +=
          this.serviceList[index].virtual_discounted_amount;
      } else if (
        !this.serviceList[index].discountStatus ||
        this.serviceList[index].discountStatus == 0
      ) {
        this.memberData.price += this.serviceList[index].virtual_rate;
      }
    }
    this.serviceList[index].toShow = false;
    this.calculateCouponDiscount();
  }
  selectServicesForEdit(item: any) {
    console.log(item);
    if (item.service_type_hash) {
      const index = this.serviceList.findIndex(
        (x: any) => x.hash_id == item.service_type_hash,
      );
      if (index != -1) {
        // this.serviceList[index].current_status = 3
        item.selectedCount = item.service_qty;
        this.serviceList[index].selectedCount = item.service_qty;
        this.serviceList[index].price = item.rate;
        this.selectedJobs.push(this.serviceList[index]);

        if (this.selectedServiceType == "0") {
          if (this.serviceList[index].discountStatus == 1) {
            this.memberData.price +=
              this.serviceList[index].homeDiscountedPrice * item.selectedCount;
          } else if (this.serviceList[index].discountStatus == 0) {
            this.memberData.price +=
              this.serviceList[index].home_rate * item.selectedCount;
          }
        } else if (this.selectedServiceType == "1") {
          if (this.serviceList[index].discountStatus == 1) {
            this.memberData.price +=
              this.serviceList[index].shopDiscountedPrice * item.selectedCount;
          } else if (this.serviceList[index].discountStatus == 0) {
            this.memberData.price +=
              this.serviceList[index].shop_rate * item.selectedCount;
          }
        } else if (this.selectedServiceType == "2") {
          if (this.serviceList[index].discountStatus == 1) {
            this.memberData.price +=
              this.serviceList[index].virtual_discounted_amount *
              item.selectedCount;
          } else if (this.serviceList[index].discountStatus == 0) {
            this.memberData.price +=
              this.serviceList[index].virtual_rate * item.selectedCount;
          }
        }
        this.serviceList[index].toShow = false;
      }
    }
    this.calculateCouponDiscount();
  }
  removeSelectedJobs(item: any) {
    console.log(item);

    const index = this.serviceList.findIndex(
      (x: any) => x.hash_id == item.hash_id,
    );
    const index1 = this.selectedJobs.findIndex(
      (x: any) => x.hash_id == item.hash_id,
    );
    this.memberData.price -= item.price;

    // if (this.selectedServiceType == "0") {
    //   if (this.selectedJobs[index1].discountStatus == 1) {
    //     this.memberData.price -=
    //       this.selectedJobs[index1].homeDiscountedPrice *
    //       this.selectedJobs[index1].selectedCount;
    //   } else if (this.selectedJobs[index1].discountStatus == 0) {
    //     this.memberData.price -=
    //       this.selectedJobs[index1].home_rate *
    //       this.selectedJobs[index1].selectedCount;
    //   }
    // } else if (this.selectedServiceType == "1") {
    //   if (this.selectedJobs[index1].discountStatus == 1) {
    //     this.memberData.price -=
    //       this.selectedJobs[index1].shopDiscountedPrice *
    //       this.selectedJobs[index1].selectedCount;
    //   } else if (this.selectedJobs[index1].discountStatus == 0) {
    //     this.memberData.price -=
    //       this.selectedJobs[index1].shop_rate *
    //       this.selectedJobs[index1].selectedCount;
    //   }
    // } else if (this.selectedServiceType == "2") {
    //   if (this.selectedJobs[index1].discountStatus == 1) {
    //     this.memberData.price -=
    //       this.selectedJobs[index1].virtual_discounted_amount *
    //       this.selectedJobs[index1].selectedCount;
    //   } else if (this.selectedJobs[index1].discountStatus == 0) {
    //     this.memberData.price -=
    //       this.selectedJobs[index1].virtual_rate *
    //       this.selectedJobs[index1].selectedCount;
    //   }
    // }

    this.serviceList[index].toShow = true;
    this.selectedJobs.splice(index1, 1);
    this.calculateCouponDiscount();
  }

  formatTime(date: Date): string {
    const hours = date.getHours().toString().padStart(2, "0"); // Ensure two digits, pad with leading zero if necessary
    const minutes = date.getMinutes().toString().padStart(2, "0"); // Same for minutes
    return `${hours}:${minutes}`;
  }

  addOneHourAndFormat(date: Date): string {
    const newDate = new Date(date);
    newDate.setHours(date.getHours() + 1);

    const hours = newDate.getHours().toString().padStart(2, "0");
    const minutes = newDate.getMinutes().toString().padStart(2, "0");

    return `${hours}:${minutes}`;
  }

  formatDateString(inputDateString: Date): string {
    const inputDate = new Date(inputDateString);
    const year = inputDate.getFullYear();
    const month = (inputDate.getMonth() + 1).toString().padStart(2, "0"); // Month is 0-indexed
    const day = inputDate.getDate().toString().padStart(2, "0");
    const hours = inputDate.getHours().toString().padStart(2, "0");
    const minutes = inputDate.getMinutes().toString().padStart(2, "0");
    const seconds = inputDate.getSeconds().toString().padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }
  tConv24(time24: any) {
    let ts: any = time24;
    let H: any = +ts.substr(0, 2);
    let h: any = H % 12 || 12;
    h = h < 10 ? "0" + h : h; // leading 0 at the left for 1 digit hours
    var ampm = H < 12 ? " AM" : " PM";
    ts = h + ts.substr(2, 3) + ampm;
    return ts;
  }
  startTime: any = null;
  endTime: any = null;
  onSelectSlot() {
    this.loader.showLoader = true;
    let dialogref = this._modelRef.open(SlotTimingsComponent, {
      data: {
        day: this.selectedDate
          ? new Date(this.selectedDate).getDay() + 1
          : new Date(this.today).getDay() + 1,
        entityHash: "jjjj",
        serviceType: this.selectedServiceType,
      },
    });
    dialogref.afterClosed().subscribe((res) => {
      if (res) {
        this.startTime = res.startTime;
        this.endTime = res.endTime;
      }
    });
  }

  removeSelectedDay(index: any) {
    console.log(index);

    this.selectedDays.splice(index, 1);
  }

  getOneHourSlot(date: Date) {
    // Convert to local time string in 24-hour format
    const localTimeString = date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });

    // Get hours and minutes
    let [hours, minutes] = localTimeString.split(":").map(Number);

    // Adjust hours based on minutes (round down to nearest hour)
    let startHour = hours;

    // Calculate next hour
    let endHour = (startHour + 1) % 24;

    // Format hours to always be 2 digits (e.g., 08:00, 23:00)
    const formatHour = (hour: any) => hour.toString().padStart(2, "0");

    // Return the 1-hour slot in 24-hour format
    return {
      start: `${formatHour(startHour)}:00`,
      end: `${formatHour(endHour)}:00`,
    };
  }
  getDayName(dayNumber: any) {
    const daysOfWeek = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];

    // Ensure the input is a valid day number (0-6)
    if (dayNumber >= 0 && dayNumber <= 6) {
      return daysOfWeek[dayNumber];
    } else {
      return "Invalid day number";
    }
  }
  isCurrentDateInRange(start_date: string, end_date: string): boolean {
    const currentDate = new Date();
    const startDate = new Date(start_date);
    const endDate = new Date(end_date);

    // Normalize the dates by setting the time to 00:00:00
    const normalizeDate = (date: Date): Date => {
      return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    };

    const normalizedCurrentDate = normalizeDate(currentDate);
    const normalizedStartDate = normalizeDate(startDate);
    const normalizedEndDate = normalizeDate(endDate);

    // Check if the current date is between start and end date (inclusive)
    return (
      normalizedCurrentDate >= normalizedStartDate &&
      normalizedCurrentDate <= normalizedEndDate
    );
  }

  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe();
  }

  changerequestStatus(status: any) {
    this.requestStatus = status;
  }

  // Create a new form group for each item
  itemOptions: string[] = ["Item1", "Item2", "Item3", "Item4"]; // List of options
  filteredOptions: Observable<any[]>[] = [];
  createItem(): UntypedFormGroup {
    const itemGroup = this.fb.group({
      name: ["", Validators.required],
      price: ["", Validators.required],
      count: [1, Validators.required],
      tax_slab: ["default"],
    });

    const filterControl = itemGroup.get("name") as UntypedFormControl;

    // Listen for changes, trigger API call if length > 3
    // const filteredOption = filterControl.valueChanges.pipe(
    //   debounceTime(300), // Add debounce to reduce API calls
    //   filter((value) => value.length > 2), // Only call API if input length > 3
    //   switchMap((value) => this.fetchOptions(value)) // Fetch options from API
    // );

    const priceControl = itemGroup.get("price") as UntypedFormControl;

    // Store the previous value to subtract when the value changes
    let previousPrice = 0;

    priceControl.valueChanges.subscribe((value) => {
      // Convert the input value to a number
      const parsedValue = +value;
      if (!isNaN(parsedValue) && value !== "" && value !== undefined) {
        // Subtract the previous price before adding the new one
        this.memberData.price = this.memberData.price - previousPrice + +value;

        // Update the previous price to the new value for future changes
        previousPrice = +value;
      } else {
      }
      this.calculateCouponDiscount();
    });

    // this.filteredOptions.push(filteredOption);
    // console.log(this.filteredOptions);

    return itemGroup;
  }

  createFieldWithItem(item: any): UntypedFormGroup {
    const itemGroup = this.fb.group({
      name: [
        {
          item_name: item.item_name,
          item_desc: item.item_description,
          hash_id: item.inventory_item_hash,
          image_thumb_url: null,
        },
        Validators.required,
      ],
      price: [item.item_price, Validators.required],
      count: [item.item_qty, Validators.required],
      tax_slab: [item.tax_slab_hash ? item.tax_slab_hash : "default"],
    });

    const filterControl = itemGroup.get("name") as UntypedFormControl;

    // const filteredOption = filterControl.valueChanges.pipe(
    //   debounceTime(300),
    //   filter((value) => typeof value === "string" && value.length > 2),
    //   switchMap((value) => this.fetchOptions(value))
    // );
    // this.filteredOptions.push(filteredOption);

    const priceControl = itemGroup.get("price") as UntypedFormControl;
    let previousPrice = item.item_price; // ✅ Fix: initialize correctly

    // ✅ Add initial item price once
    this.memberData.price += item.item_price;

    // ✅ Skip first emission to prevent double count
    priceControl.valueChanges.subscribe((value) => {
      const parsedValue = +value;
      if (!isNaN(parsedValue) && value !== "" && value !== undefined) {
        this.memberData.price =
          this.memberData.price - previousPrice + parsedValue;
        previousPrice = parsedValue;
      }
      this.calculateCouponDiscount();
    });

    return itemGroup;
  }

  displayItemName(item: any): string {
    return item ? item.item_name : ""; // Return only the item_name for display
  }

  // Call the API to fetch options based on the user's input
  fetchOptions(value: string): Observable<string[]> {
    // Example API call: Replace with your actual API endpoint
    return this.http.get<string[]>(
      `https://user-services.lookzup.com/dev/getInventoryDataByKeyword?entityHashId=${this.parentData.data.entityHash}&searchKey=${value}&pageNo=1&count=25`,
    );
  }

  // Filter the autocomplete options based on the user's input
  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.itemOptions.filter((option) =>
      option.toLowerCase().includes(filterValue),
    );
  }

  // Get the form array of items
  get items(): UntypedFormArray {
    return this.form.get("items") as UntypedFormArray;
  }

  // Add new form field
  addFormField(): void {
    this.items.push(this.createItem());
  }

  // Remove a form field by index
  removeFormField(index: number): void {
    this.memberData.price -= +this.items.at(index).value.price;

    this.items.removeAt(index);
    this.calculateCouponDiscount();
  }

  // Decrease the count and remove the form if count becomes 0
  decreaseCount(index: number): void {
    const currentItem = this.items.at(index);
    const currentCount = currentItem.get("count")!.value;

    if (currentCount > 1) {
      currentItem.get("count")!.setValue(currentCount - 1);
    } else {
      // this.memberData.price -= +currentItem.get('price')!.value
      this.removeFormField(index); // Remove the form when count is 0
    }
  }

  // Increase the count
  increaseCount(index: number): void {
    const currentItem = this.items.at(index);
    currentItem.get("count")!.setValue(currentItem.get("count")!.value + 1);
  }

  formatDate(originalDate: string): string {
    const parts = originalDate.split("/");
    const day = +parts[0];
    const month = +parts[1] - 1; // Months are 0-based in JavaScript
    const year = +parts[2];
    const date = new Date(year, month, day);

    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0"); // Adding 1 to month since it's 0-based
    const dd = String(date.getDate()).padStart(2, "0");

    return `${yyyy}-${mm}-${dd}`;
  }

  selectedProducts: any = [];
  selectProducts(item: any) {
    if (item.entity_product_hash) {
      console.log(item);

      const index = this.productsList.findIndex(
        (x: any) => x.hash_id == item.entity_product_hash,
      );
      if (index != -1) {
        this.productsList[index].selectedCount = item.product_qty;
        item.selectedCount = item.product_qty;
        this.productsList[index].price = item.rate;
        this.selectedProducts.push(this.productsList[index]);
        if (this.selectedServiceType == "0") {
          if (
            this.productsList[index].discount_status &&
            this.productsList[index].discount_status == 1
          ) {
            this.memberData.price +=
              this.productsList[index].home_discounted_price;
          } else if (
            !this.productsList[index].discount_status ||
            this.productsList[index].discount_status == 0
          ) {
            this.memberData.price += this.productsList[index].home_price;
          }
        } else if (this.selectedServiceType == "1") {
          if (
            this.productsList[index].discount_status &&
            this.productsList[index].discount_status == 1
          ) {
            this.memberData.price +=
              this.productsList[index].shop_discounted_price;
          } else if (
            !this.productsList[index].discount_status ||
            this.productsList[index].discount_status == 0
          ) {
            this.memberData.price += this.productsList[index].shop_price;
          }
        } else if (this.selectedServiceType == "2") {
          if (
            this.productsList[index].discount_status &&
            this.productsList[index].discount_status == 1
          ) {
            this.memberData.price +=
              this.productsList[index].virtual_discounted_price;
          } else if (
            !this.productsList[index].discount_status ||
            this.productsList[index].discount_status == 0
          ) {
            this.memberData.price += this.productsList[index].virtual_price;
          }
        }
        this.productsList[index].toShow = false;
      }
    } else if (item.hash_id) {
      console.log(item);

      const index = this.productsList.findIndex(
        (x: any) => x.hash_id == item.hash_id,
      );
      this.productsList[index].selectedCount = 1;
      this.productsList[index].price =
        this.selectedServiceType == "0"
          ? item.discount_status == 1
            ? item.home_discounted_price
            : item.home_price
          : this.selectedServiceType == "1"
          ? item.discount_status == 1
            ? item.shop_discounted_price
            : item.shop_price
          : item.discount_status == 1
          ? item.virtual_discounted_price
          : item.virtual_price;
      this.selectedProducts.push(this.productsList[index]);
      if (this.selectedServiceType == "0") {
        if (
          this.productsList[index].discount_status &&
          this.productsList[index].discount_status == 1
        ) {
          this.memberData.price +=
            this.productsList[index].home_discounted_price;
        } else if (
          !this.productsList[index].discount_status ||
          this.productsList[index].discount_status == 0
        ) {
          this.memberData.price += this.productsList[index].home_price;
        }
      } else if (this.selectedServiceType == "1") {
        if (
          this.productsList[index].discount_status &&
          this.productsList[index].discount_status == 1
        ) {
          this.memberData.price +=
            this.productsList[index].shop_discounted_price;
        } else if (
          !this.productsList[index].discount_status ||
          this.productsList[index].discount_status == 0
        ) {
          this.memberData.price += this.productsList[index].shop_price;
        }
      } else if (this.selectedServiceType == "2") {
        if (
          this.productsList[index].discount_status &&
          this.productsList[index].discount_status == 1
        ) {
          this.memberData.price +=
            this.productsList[index].virtual_discounted_price;
        } else if (
          !this.productsList[index].discount_status ||
          this.productsList[index].discount_status == 0
        ) {
          this.memberData.price += this.productsList[index].virtual_price;
        }
      }
      this.productsList[index].toShow = false;
    }
    this.calculateCouponDiscount();
  }

  decreaseProductCount(item: any, index: any) {
    if (this.selectedProducts[index].selectedCount == 1) {
      const index1 = this.productsList.findIndex(
        (x: any) => x.hash_id == item.hash_id,
      );
      // const index1 = this.selectedProducts.findIndex( (x:any)=>x.hash_id == item.hash_id);

      if (this.selectedServiceType == "0") {
        if (this.selectedProducts[index].discount_status == 1) {
          this.memberData.price -=
            this.selectedProducts[index].home_discounted_price;
        } else if (this.selectedProducts[index].discount_status == 0) {
          this.memberData.price -= this.selectedProducts[index].home_price;
        }
      } else if (this.selectedServiceType == "1") {
        if (this.selectedProducts[index].discount_status == 1) {
          this.memberData.price -=
            this.selectedProducts[index].shop_discounted_price;
        } else if (this.selectedProducts[index].discount_status == 0) {
          this.memberData.price -= this.selectedProducts[index].shop_price;
        }
      } else if (this.selectedServiceType == "2") {
        if (this.selectedProducts[index].discount_status == 1) {
          this.memberData.price -=
            this.selectedProducts[index].virtual_discounted_price;
        } else if (this.selectedProducts[index].discount_status == 0) {
          this.memberData.price -= this.selectedProducts[index].virtual_price;
        }
      }

      this.productsList[index1].toShow = true;
      this.selectedProducts.splice(index, 1);
    } else {
      item.price -= item.price / item.selectedCount;
      this.selectedProducts[index].selectedCount--;

      if (this.selectedServiceType == "0") {
        if (this.selectedProducts[index].discount_status == 1) {
          this.memberData.price -=
            this.selectedProducts[index].home_discounted_price;
        } else if (this.selectedProducts[index].discount_status == 0) {
          this.memberData.price -= this.selectedProducts[index].home_price;
        }
      } else if (this.selectedServiceType == "1") {
        if (this.selectedProducts[index].discount_status == 1) {
          this.memberData.price -=
            this.selectedProducts[index].shop_discounted_price;
        } else if (this.selectedProducts[index].discount_status == 0) {
          this.memberData.price -= this.selectedProducts[index].shop_price;
        }
      } else if (this.selectedServiceType == "2") {
        if (this.selectedProducts[index].discount_status == 1) {
          this.memberData.price -=
            this.selectedProducts[index].virtual_discounted_price;
        } else if (this.selectedProducts[index].discount_status == 0) {
          this.memberData.price -= this.selectedProducts[index].virtual_price;
        }
      }
    }
    this.calculateCouponDiscount();
  }
  increaseProductCount(item: any, index: any) {
    item.price += item.price / item.selectedCount;
    this.selectedProducts[index].selectedCount++;

    // const index = this.serviceList.findIndex( (x:any)=>x.hash_id == item.hash_id);
    // const index1 = this.selectedProducts.findIndex( (x:any)=>x.hash_id == item.hash_id);

    if (this.selectedServiceType == "0") {
      if (this.selectedProducts[index].discount_status == 1) {
        this.memberData.price +=
          this.selectedProducts[index].home_discounted_price;
      } else if (this.selectedProducts[index].discount_status == 0) {
        this.memberData.price += this.selectedProducts[index].home_price;
      }
    } else if (this.selectedServiceType == "1") {
      if (this.selectedProducts[index].discount_status == 1) {
        this.memberData.price +=
          this.selectedProducts[index].shop_discounted_price;
      } else if (this.selectedProducts[index].discount_status == 0) {
        this.memberData.price += this.selectedProducts[index].shop_price;
      }
    } else if (this.selectedServiceType == "2") {
      if (this.selectedProducts[index].discount_status == 1) {
        this.memberData.price +=
          this.selectedProducts[index].virtual_discounted_price;
      } else if (this.selectedProducts[index].discount_status == 0) {
        this.memberData.price += this.selectedProducts[index].virtual_price;
      }
    }
    this.calculateCouponDiscount();
  }

  removeSelectedProducts(item: any) {
    console.log(item);

    const index = this.productsList.findIndex(
      (x: any) => x.hash_id == item.hash_id,
    );
    const index1 = this.selectedProducts.findIndex(
      (x: any) => x.hash_id == item.hash_id,
    );
    this.memberData.price -= item.price;
    // if (this.selectedServiceType == "0") {
    //   if (this.selectedProducts[index1].discount_status == 1) {
    //     this.memberData.price -=
    //       this.selectedProducts[index1].home_discounted_price *
    //       this.selectedProducts[index1].selectedCount;
    //   } else if (this.selectedProducts[index1].discount_status == 0) {
    //     this.memberData.price -=
    //       this.selectedProducts[index1].home_price *
    //       this.selectedProducts[index1].selectedCount;
    //   }
    // } else if (this.selectedServiceType == "1") {
    //   if (this.selectedProducts[index1].discount_status == 1) {
    //     this.memberData.price -=
    //       this.selectedProducts[index1].shop_discounted_price *
    //       this.selectedProducts[index1].selectedCount;
    //   } else if (this.selectedProducts[index1].discount_status == 0) {
    //     this.memberData.price -=
    //       this.selectedProducts[index1].shop_price *
    //       this.selectedProducts[index1].selectedCount;
    //   }
    // } else if (this.selectedServiceType == "2") {
    //   if (this.selectedProducts[index1].discount_status == 1) {
    //     this.memberData.price -=
    //       this.selectedProducts[index1].virtual_discounted_price *
    //       this.selectedProducts[index1].selectedCount;
    //   } else if (this.selectedProducts[index1].discount_status == 0) {
    //     this.memberData.price -=
    //       this.selectedProducts[index1].virtual_price *
    //       this.selectedProducts[index1].selectedCount;
    //   }
    // }

    this.productsList[index].toShow = true;
    this.selectedProducts.splice(index1, 1);
    this.calculateCouponDiscount();
  }

  changeProductPrice(item: any) {
    console.log(item.price);
    this.memberData.price = 0;
    this.selectedJobs.forEach((element: any) => {
      this.memberData.price += element.price;
    });
    this.selectedProducts.forEach((element: any) => {
      this.memberData.price += element.price;
    });
    this.form.get("items")!.value.forEach((element: any) => {
      this.memberData.price += +element.price;
    });

    this.checkIfEmptyForProduct();
    this.calculateCouponDiscount();
    // this.calculateDiscount()
  }

  emptyCheckForProduct: boolean = false;
  checkIfEmptyForProduct() {
    this.selectedProducts.forEach((element: any) => {
      if (element.price == null || element.price == "") {
        this.emptyCheckForProduct = true;
      } else {
        this.emptyCheckForProduct = false;
      }
    });
  }

  emptyCheck: boolean = false;
  checkIfEmpty() {
    this.selectedJobs.forEach((element: any) => {
      if (element.price == null || element.price == "") {
        this.emptyCheck = true;
      } else {
        this.emptyCheck = false;
      }
    });
    console.log(this.emptyCheck);
  }

  changeServicePrice(item: any) {
    console.log(item.price);
    this.memberData.price = 0;
    this.selectedJobs.forEach((element: any) => {
      this.memberData.price += element.price;
    });
    this.selectedProducts.forEach((element: any) => {
      this.memberData.price += element.price;
    });
    this.form.get("items")!.value.forEach((element: any) => {
      this.memberData.price += +element.price;
    });

    this.checkIfEmpty();
    this.calculateCouponDiscount();
    // this.calculateDiscount()
  }

  calculateCouponDiscount() {
    if (this.memberData.coupon_code) {
      this.memberData.coupon_discount = 0;
      console.log("inside coupon");

      // percentage discount
      if (this.parentData.data.memberData.coupon_info.discount_type == 1) {
        if (
          this.memberData.price >=
          this.parentData.data.memberData.coupon_info.minimum_cart_value
        ) {
          let cal_disc =
            (+this.parentData.data.memberData.coupon_info.discount_value /
              100) *
            +this.memberData.price;
          if (
            cal_disc >= this.parentData.data.memberData.coupon_info.max_discount
          ) {
            this.memberData.coupon_discount =
              this.parentData.data.memberData.coupon_info.max_discount;
          } else {
            this.memberData.coupon_discount = cal_disc;
          }
          // // home service
          // if (this.parentData.data.serviceType == "0") {
          //   if (this.discountInfo.home_service_status == 1) {
          //   }
          // }
          // // shop service
          // else if (this.parentData.data.serviceType == "1") {
          //   if (this.discountInfo.shop_service_status == 1) {
          //     let cal_disc =
          //       (+this.discountInfo.discountAmount / 100) *
          //       +this.memberData.price;
          //     console.log(cal_disc);

          //     if (cal_disc >= this.discountInfo.maxDiscount) {
          //       this.newbookingData.discount = this.discountInfo.maxDiscount;
          //     } else {
          //       this.newbookingData.discount = cal_disc;
          //     }
          //   }
          // }
          // // virtual service
          // else if (this.parentData.data.serviceType == "2") {
          //   if (this.discountInfo.virtual_service_status == 1) {
          //     let cal_disc =
          //       (+this.discountInfo.discountAmount / 100) *
          //       +this.memberData.price;
          //     console.log(cal_disc);

          //     if (cal_disc >= this.discountInfo.maxDiscount) {
          //       this.newbookingData.discount = this.discountInfo.maxDiscount;
          //     } else {
          //       this.newbookingData.discount = cal_disc;
          //     }
          //   }
          // }
        }
      }
      // amount discount
      else if (this.parentData.data.memberData.coupon_info.discount_type == 2) {
        if (
          this.memberData.price >=
          this.parentData.data.memberData.coupon_info.minimum_cart_value
        ) {
          this.memberData.coupon_discount =
            this.parentData.data.memberData.coupon_info.discount_value;

          // // home service
          // if (this.parentData.data.serviceType == "0") {
          //   if (this.discountInfo.home_service_status == 1) {
          //   }
          // }
          // // shop service
          // else if (this.parentData.data.serviceType == "1") {
          //   if (this.discountInfo.shop_service_status == 1) {
          //     this.newbookingData.discount = this.discountInfo.discountAmount;
          //   }
          // }
          // // virtual service
          // else if (this.parentData.data.serviceType == "2") {
          //   if (this.discountInfo.virtual_service_status == 1) {
          //     this.newbookingData.discount = this.discountInfo.discountAmount;
          //   }
          // }
        }
      }

      // this.newbookingData.discount = +this.newbookingData.discount.toFixed(2);
    }
  }

  step: number = 1;

  goback() {
    this.scrollToTop();
    this.step -= 1;
  }
  gonext() {
    this.scrollToTop();
    this.step += 1;
    if (this.selectedServiceType == "0") {
      this.toShowMap = true;
      this.toShowSessionInfo = false;
      if (this.step == 4) {
        this.phone = this.memberData.phone;
        this.contactselectedCountryCode = this.countryList.find(
          (country) => country.dial_code === this.selectedCountryCode.dial_code,
        );

        if (!this.formattedAddress) {
          setTimeout(() => {
            this.initializeMap(
              {
                latitude: "28.6139298",
                longitude: "77.2088282",
              },
              "New Delhi, Delhi, India",
            );
          }, 1);
        } else {
          setTimeout(() => {
            this.initializeMap(
              {
                latitude: this.lat,
                longitude: this.lng,
              },
              this.formattedAddress,
            );
          }, 1);
        }
      }
    } else if (this.selectedServiceType == "2") {
      this.toShowSessionInfo = true;
      this.toShowMap = false;
    } else {
      this.toShowMap = this.toShowSessionInfo = false;
    }
  }

  private scrollToTop() {
    if (this.modalContainer) {
      const container = this.modalContainer.nativeElement;

      // Get the current scroll position
      const currentPos = container.scrollTop;

      // Subtract pixels (e.g., 100px or 150px) to scroll "above" the current view
      const offset = 100;

      container.scrollTo({
        top: currentPos - offset,
        behavior: "smooth",
      });
    }
  }

  getDisabledStatus(): boolean {
    if (this.step === 1) {
      return (
        this.formChecker() || this.namechecker() || !this.memberData.start_date
      );
    } else if (this.step === 2) {
      return (
        this.selectedJobs.length == 0 ||
        this.selectedDaysChecker() ||
        this.form.invalid ||
        this.checkIfEmpty2() ||
        this.checkIfEmptyForProduct2()
      );
    } else if (this.step === 3) {
      return false;
    }

    return false;
  }

  checkIfEmpty2() {
    return this.selectedJobs.some(
      (element: any) => element.price === "" || element.price == null,
    );
  }

  checkIfEmptyForProduct2() {
    return this.selectedProducts.some(
      (element: any) => element.price === "" || element.price == null,
    );
  }


  // -------------------- MAP THINGS ---------------------------
  @ViewChild("mapContainer", { static: false }) mapContainer!: ElementRef;
  contactselectedCountryCode: any = this.countryList.find(
    (country) =>
      country.dial_code === this.countryInfo.countryCode &&
      country.code === this.countryInfo.code,
  );
  houseNumber: any;
  streetName: any;
  landmark: any;
  phone: any;
  map!: google.maps.Map;
  marker!: google.maps.Marker;
  geocoder!: google.maps.Geocoder;
  lat: any;
  lng: any;
  initializeMap(address?: any, description?: any) {
    let mapOptions: google.maps.MapOptions;

    if (address && address.latitude && address.longitude) {
      this.lat = address.latitude;
      this.lng = address.longitude;
      mapOptions = {
        center: new google.maps.LatLng(address.latitude, address.longitude),
        zoom: 12,
      };
    } else {
      mapOptions = {
        center: new google.maps.LatLng(28.6139298, 77.2088282), // fallback (Delhi for example)
        zoom: 5,
      };
    }

    this.map = new google.maps.Map(this.mapContainer.nativeElement, mapOptions);

    // Create marker only if coordinates exist
    if (address && address.latitude && address.longitude) {
      this.marker = new google.maps.Marker({
        map: this.map,
        draggable: true,
        position: mapOptions.center,
      });

      this.geocoder = new google.maps.Geocoder();
      const latLng = new google.maps.LatLng(
        address.latitude,
        address.longitude,
      );
      this.geocodePosition(latLng, description);

      google.maps.event.addListener(this.marker, "dragend", (event: any) => {
        this.geocodePositionOverwrite(event.latLng);
      });
    }
  }

  // this.storeLocation( results[ 0 ].address_components, results[ 0 ].formatted_address );
  geocodePosition(latLng: google.maps.LatLng, description?: any) {
    console.log(latLng);
    console.log(description);

    this.geocoder.geocode({ location: latLng }, (results, status) => {
      if (status === google.maps.GeocoderStatus.OK) {
        if (results[0]) {
          console.log(results[0]);
          // this.autocomplete.nativeElement.value = results[0].formatted_address;
          console.log("Address:", results[0].formatted_address);
          this.storeLocation(
            results[0].address_components,
            results[0].formatted_address,
            description ? description : results[0].formatted_address,
          );
          const location = results[0].geometry.location;
          this.lat = location.lat().toFixed(6);
          this.lng = location.lng().toFixed(6);
          console.log(this.lat, this.lng);
        } else {
          console.log("No results found");
        }
      } else {
        console.log("Geocoder failed due to:", status);
      }
    });
  }
  geocodePositionOverwrite(latLng: google.maps.LatLng) {
    console.log(latLng);

    this.geocoder.geocode({ location: latLng }, (results, status) => {
      if (status === google.maps.GeocoderStatus.OK) {
        if (results[0]) {
          console.log(results[0]);
          // this.autocomplete.nativeElement.value = results[0].formatted_address;
          console.log("Address:", results[0].formatted_address);
          this.storeLocation(
            results[0].address_components,
            results[0].formatted_address,
            results[0].formatted_address,
          );
          const location = results[0].geometry.location;
          this.lat = location.lat().toFixed(6);
          this.lng = location.lng().toFixed(6);
        } else {
          console.log("No results found");
        }
      } else {
        console.log("Geocoder failed due to:", status);
      }
    });
  }

  // async getCurrentLocation(): Promise<any> {
  //   return new Promise(async (resolve, reject) => {
  //     if ('geolocation' in navigator) {
  //       navigator.geolocation.getCurrentPosition(
  //         async position => {
  //           const { latitude, longitude } = position.coords;
  //           try {
  //             resolve({ latitude, longitude});
  //           } catch (error) {
  //             reject('Error getting location info');
  //           }
  //         },
  //         error => reject(error)
  //       );
  //     } else {
  //       reject('Geolocation is not supported by your browser.');
  //     }
  //   });
  // }

  // async getCurrentLocation(): Promise<any> {
  //   try {
  //     const position = await Geolocation.getCurrentPosition();
  //     const coords = position.coords;
  //     console.log(JSON.stringify(position));

  //     return {
  //       latitude: coords.latitude.toString(),
  //       longitude: coords.longitude.toString(),
  //     };
  //   } catch (err) {
  //     console.error("Error fetching location", err);
  //     throw err;
  //   }
  // }
  location: any = "";
  targetaddress: any = "";
  selectedLocation: any = {};
  formattedAddress: any;
  storeLocation(location: any, formatted_address: any, description: any) {
    console.log(location);
    let address: any = {
      latitude: "",
      longitude: "",
      city: "",
      state: "",
      country: "",
      sublocality_level_1: "",
      zip: "",
    };

    location?.forEach((data: any) => {
      let type = data.types[0];
      console.log(type);
      if (type === "postal_code") {
        address.zip = data.long_name;
      } else if (type === "locality") {
        address.city = data.long_name;
      } else if (type === "administrative_area_level_1") {
        address.state = data.long_name;
      } else if (type === "country") {
        address.country = data.long_name;
      } else if (data.types.includes("sublocality_level_1")) {
        address.sublocality_level_1 = data.long_name;
      }
    });

    console.log(address);

    // ---------- ASSIGN TO KEYWORD ---------------

    const addressComponents = location || [];
    const priorityMap: any = {
      locality: null,
      administrative_area_level_1: null,
      country: null,
    };

    // Extract values based on priority
    addressComponents.forEach((data: any) => {
      const type = data.types[0];
      if (type in priorityMap && !priorityMap[type]) {
        priorityMap[type] = data.long_name;
      }
    });

    // Assign location based on priority
    this.location =
      priorityMap.locality ||
      priorityMap.administrative_area_level_1 ||
      priorityMap.country;

    address.latitude = this.lat ?? "";
    address.longitude = this.lng ?? "";
    address.formatted_address = description ?? "";

    this.selectedLocation = address;
    console.log(this.selectedLocation);

    this.formattedAddress = description;
    console.log(this.formattedAddress);
  }

  locationInput: string = "";
  googleAutoCompleteItems: any[] = [];
  GoogleAutocomplete: any;

  onInputChange() {
    this.locationSelected = false;
    if (!this.formattedAddress.trim()) {
      this.googleAutoCompleteItems = [];
      return;
    }

    this.GoogleAutocomplete.getPlacePredictions(
      { input: this.formattedAddress },
      (predictions: any, status: any) => {
        if (
          status === google.maps.places.PlacesServiceStatus.OK &&
          predictions
        ) {
          this.googleAutoCompleteItems = predictions;
        }
      },
    );

    console.log(this.googleAutoCompleteItems);
  }

  locationSelected = false;
  selectItem(item: any) {
    this.locationSelected = true; // ✅ user picked from list
    console.log(item);
    this.googleAutoCompleteItems = [];
    this.geocoder.geocode(
      {
        placeId: item.place_id,
      },
      (results: any, status: any) => {
        if (status === "OK" && results[0]) {
          this._ngZone.run(() => {
            // this.profileData.address_line = results[0].formatted_address;

            // this.locationSelected = true;
            let location_set: any = JSON.stringify(results[0].geometry);
            location_set = JSON.parse(location_set);
            let position = {
              lat: results[0].geometry.location.lat,
              lng: results[0].geometry.location.lng,
            };
            this.lat = location_set.location.lat;
            this.lng = location_set.location.lng;
            console.log(this.lat, this.lng);
            console.log("Latitude & Langitude", position);
            this.updateMapCoordinates(this.lat, this.lng, item.description);
            this.storeLocation(
              results[0].address_components,
              results[0].formatted_address,
              item.description,
            );
          });
        }
      },
    );
  }

  /**
   * Update map center and marker without recreating the google map instance.
   * lat/lng can be numbers or numeric strings.
   * opts: { zoom?: number, animate?: boolean } - animate isn't used (Google Maps JS has no built-in smooth pan),
   * but we keep opts for future extension.
   */
  updateMapCoordinates(
    lat: number | string,
    lng: number | string,
    description?: any,
  ) {
    const latNum = Number(lat);
    const lngNum = Number(lng);
    if (isNaN(latNum) || isNaN(lngNum)) {
      console.warn("updateMapCoordinates: invalid lat/lng", lat, lng);
      return;
    }

    // ensure map exists
    if (!this.map) {
      // If map hasn't been created yet, call initializeMap with these coords
      this.initializeMap({ latitude: latNum, longitude: lngNum }, description);
      return;
    }

    const latLng = new google.maps.LatLng(latNum, lngNum);
    this.map.setZoom(12);

    // center map
    this.map.setCenter(latLng);

    // create marker if missing
    if (!this.marker) {
      this.marker = new google.maps.Marker({
        map: this.map,
        draggable: true,
        position: latLng,
      });

      // add dragend listener once when marker created
      google.maps.event.addListener(this.marker, "dragend", (event: any) => {
        this.geocodePositionOverwrite(event.latLng);
      });
    } else {
      // move existing marker
      this.marker.setPosition(latLng);
    }

    // update geocoder results & component state
    if (!this.geocoder) this.geocoder = new google.maps.Geocoder();
    this.geocodePosition(latLng, description);

    // keep internal lat/lng in sync (string with fixed decimals if you prefer)
    this.lat = latNum.toFixed ? latNum.toFixed(6) : latNum;
    this.lng = lngNum.toFixed ? lngNum.toFixed(6) : lngNum;
  }
}
